import React, { createContext, useState } from 'react';

export const AppContext = createContext(null);

// 30 days in ms
const msDays = 30 * 24 * 60 * 60 * 1000;

export const ContextWrapper = (props) => {
  const [startDate, setStartDate] = useState(new Date(Date.now() - msDays));
  const [endDate, setEndDate] = useState(new Date());
  const [store, setStore] = useState({
    expandedEventLogs: {},
    activeTransfers: [],
  });

  const [actions] = useState({
    setExpandedEventLog: (transferId, value = true) => setStore({
      ...store,
      expandedEventLogs: Object.assign(store.expandedEventLogs, { [transferId]: value }),
    }),
    setActiveTransfers: (activeTransfers = []) => setStore({
      ...store,
      activeTransfers,
      hasActiveTransfers: !!activeTransfers.length,
    }),
    // override
    setHasActiveTransfers: (hasActiveTransfers) => setStore({
      ...store, hasActiveTransfers,
    }),
    setStartDate,
    setEndDate,
  });

  return (
    <AppContext.Provider value={{ store, startDate, endDate, actions }}>
      {props.children}
    </AppContext.Provider>
  );
};
